import { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyles, { font } from '@/modules/defines/styles';
import RouterComponent from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <GlobalStyles />
        <ThemeProvider theme={{ font }}>
          <RouterComponent />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
